import { createSelector } from 'reselect'
import adminOnboardingOfferTitleSelector from 'redux/selectors/admin_onboarding/admin_onboarding_offer_title_selector'

const getAdminOnboardingData = state => state.adminOnboarding

const adminOnboardingPremiumActivities = createSelector(
	[getAdminOnboardingData, adminOnboardingOfferTitleSelector],
	(adminOnboarding, offerTitleSelector) => ({
		offerTitle: offerTitleSelector.offerTitle,
		premiumActivitiesAddLessonStep: adminOnboarding.premiumActivitiesAddLessonStep ? adminOnboarding.premiumActivitiesAddLessonStep : 0,
	})
)

export default adminOnboardingPremiumActivities
